export const calculateAmountWithPercentage = (amount: number, percentage: number) => {
  // const percentage = 3.3;

  // 3.3% 계산한 금액 -> 관리자 요율로 변경
  const calculatedAmount = (amount * percentage) / 100;

  // 10의 자리에서 반올림
  const roundedCalculatedAmount = Math.round(calculatedAmount / 10) * 10;

  // 원래 가격에서 3.3%를 뺀 금액
  const amountAfterDeduction = amount - roundedCalculatedAmount;

  return {
    calculatedAmount: roundedCalculatedAmount,
    amountAfterDeduction,
  };
};

export const toPrice = (price: number): string => {
  const lang = localStorage.getItem("language");

  if (lang === "ko") {
    // 한국어일 경우: 숫자 뒤에 "원" 추가
    return `${price.toLocaleString()} 원`;
  } else {
    // 영어일 경우: 숫자 앞에 "₩" 추가
    return `₩ ${price.toLocaleString()}`;
  }
};


export   const formatDate = (isoString?: string) => {
    if (!isoString) return "";

    const date = new Date(isoString);
    const year = date.getFullYear();
    const month = date.getMonth() + 1; // 0-based
    const day = date.getDate();
    const hour = date.getHours();
    const minute = String(date.getMinutes()).padStart(2, "0");
    const second = String(date.getSeconds()).padStart(2, "0");

    return `${year}. ${month}. ${day} ${hour}:${minute}:${second}`;
  };

export const getOsType = (): "android" | "ios" | "other" => {
  const userAgent = navigator.userAgent.toLowerCase();

  if (/android/i.test(userAgent)) {
    return "android";
  }
  if (/ipad|iphone|ipod/.test(userAgent)) {
    return "ios";
  }
  return "other";
}